/**
 * This page and folder created for KPMG client demo,
 * KnowledegeHubTemp is temporary folder and should be removed after the demo
 * These files nothing to do with the actual product
 **/
import { Button, Card, Col, Input, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import axios, { AxiosError, AxiosResponse } from "axios";

import { Fade } from "react-awesome-reveal";
import { Icon } from "@iconify/react";
import KnowledgeHubBanner from "@assets/KPMG/Banner/KnowledgeHub.jpg";
import LogoMin from "@assets/KPMG/Logo.svg";
import UserIcon from "@assets/KPMG/User.svg";
import { WrapperLayout } from "~/Components/WrapperLayout/WrapperLayout";
import { isEmpty } from "lodash";
import { mockData } from "./mock";
import { useNavigate } from "react-router-dom";
import { useQuery } from "~/Hooks/useQuery";

export const KnowledgeHubTemp = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const query = useQuery();
  const queryString = query.get("q")?.toString();
  const [faqList, setFaqList] = useState<any>([]);

  useEffect(() => {
    let selectedFAQ = localStorage.getItem("selectedFAQ");
    if (queryString) {
      // setSearchText(queryString);
      addNew(queryString);
    } else if (selectedFAQ && selectedFAQ.length > 0) {
      addNew(selectedFAQ);
      localStorage.removeItem("selectedFAQ");
    }
    setFaqList(mockData.faqList);
  }, []);

  const addNew = (question: string) => {
    if (isEmpty(question)) {
      return;
    }
    let tempData = [...data];
    let obj = {
      question: question,
      answer: "",
      isLoading: true,
    };
    tempData.push(obj);
    setData([...data, obj]);
    setSearchText("");
    axios
      .post(
        "/bot/api/chat",
        { text: question },
        {}
      )
      .then((res: AxiosResponse) => {
        // console.log("res", res.data);
        if (res) {
          let newData = [...tempData];
          newData[newData.length - 1].answer = res.data;
          newData[newData.length - 1].isLoading = false;
          setData(newData);
        }
      })
      .catch((err: AxiosError) => {
        console.log("err", err);
        let newData = [...tempData];
        newData[newData.length - 1].answer =
          "Oops, something went wrong. Please try again later.";
        newData[newData.length - 1].isLoading = false;
        setData(newData);
        setSearchText("");
      });
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <img
          src={KnowledgeHubBanner}
          style={{ width: "100%", objectFit: "cover", maxHeight: 400 }}
        />
        <div
          style={{ position: "absolute", height: 400, top: 0, width: "100%" }}
        >
          <div
            className="d-flex align-center"
            style={{ paddingLeft: 80, height: "100%" }}
          >
            <Fade direction="left" triggerOnce>
              <Typography.Title
                level={1}
                style={{ color: "#fff", marginBottom: 40 }}
              >
                KPMG KymChat
              </Typography.Title>
            </Fade>
          </div>
        </div>
      </div>
      <WrapperLayout
        title={"KPMG KymChat"}
        text={""}
        // image={KnowledgeHubImg}
      >
        {/* <>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Icon
              icon="ic:outline-home"
              height="20"
              onClick={() => navigate("/")}
              style={{
                margin: "auto",
                //   color: styles.strawberry,
                cursor: "pointer",
              }}
            />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => navigate("/knowledge-hub")}>Knowledge Hub</a>
          </Breadcrumb.Item>
        </Breadcrumb>
      </> */}

        <Row style={{ paddingTop: 0 }}>
          <Col span={4}></Col>
          <Col span={16} style={{ marginBottom: 20 }}>
            {/* <Typography.Title
              level={2}
              style={{ marginBottom: 20 }}
            >
              KPMG KymChat
            </Typography.Title> */}
            <Row>
              {data &&
                data.map((item: any) => (
                  <Col span={24}>
                    <div>
                      <Row>
                        <Col span={6}></Col>
                        <Col span={18}>
                          {/* <Fade direction="right" triggerOnce> */}
                          <div style={{ display: "flex", marginBottom: 10 }}>
                            <div
                              style={{
                                background: "#003087",
                                padding: "12px 24px",
                                color: "#fff",
                                borderTopLeftRadius: 20,
                                borderTopRightRadius: 20,
                                borderBottomLeftRadius: 20,
                                display: "flex",
                                width: "100%",
                                alignItems: "flex-end",
                              }}
                            >
                              <div className="textSmall">{item.question}</div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-end",
                                marginLeft: 10,
                              }}
                            >
                              <img src={UserIcon} style={{ maxWidth: 20 }} />
                            </div>
                          </div>
                          {/* </Fade> */}
                        </Col>
                      </Row>
                      <Row>
                        <Col span={18}>
                          {/* <Fade direction="left" triggerOnce> */}
                          <div style={{ display: "flex", marginBottom: 20 }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-end",
                                marginRight: 10,
                              }}
                            >
                              <img src={LogoMin} style={{ maxWidth: 48 }} />
                            </div>

                            <div
                              style={{
                                background: "#fff",
                                padding: "12px 24px",
                                boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.16)",
                                borderTopRightRadius: 20,
                                borderBottomRightRadius: 20,
                                borderBottomLeftRadius: 20,
                                display: "flex",
                                width: "100%",
                                alignItems: "flex-end",
                              }}
                            >
                              {item.isLoading && (
                                <Icon
                                  icon="eos-icons:three-dots-loading"
                                  color="#29256e"
                                  fontSize={24}
                                />
                              )}
                              {!item.isLoading && (
                                <div style={{ fontSize: 14, fontWeight: 400 }}>
                                  <Fade cascade damping={0.04} triggerOnce>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item.answer,
                                      }}
                                      className="white-space-pre-line"
                                    ></div>
                                  </Fade>
                                </div>
                              )}
                            </div>
                          </div>
                          {/* </Fade> */}
                        </Col>
                        <Col span={6}></Col>
                      </Row>
                    </div>
                  </Col>
                ))}
              <Col span={24}>
                <div style={{ display: "flex" }}>
                  <div style={{ paddingTop: 0, width: "100%" }}>
                    <div style={{ marginTop: 20 }}>
                      <div style={{ display: "flex" }}>
                        <Input
                          placeholder="Ask AI to find anything"
                          style={{ height: 42 }}
                          value={searchText}
                          onChange={(e) => {
                            setSearchText(e.target.value);
                          }}
                          onPressEnter={(e) => addNew(searchText)}
                        />
                        <Button
                          type="primary"
                          className="btn-primary"
                          style={{
                            height: 42,
                            borderRadius: "24 !important",
                            marginLeft: -50,
                            minWidth: 100,
                          }}
                          onClick={() => addNew(searchText)}
                        >
                          ASK
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={24} style={{ paddingTop: 20, paddingBottom: 20 }}>
                <Typography.Title level={4}>
                  Frequently Asked Questions
                </Typography.Title>
                {faqList.map((item: any, index: number) => {
                  return (
                    <div style={{ borderBottom: "1px solid #d9d9d9" }}>
                      <Row
                        style={{
                          paddingTop: 10,
                          paddingBottom: 10,
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          addNew(item.question);
                        }}
                      >
                        <Col span={2}>
                          <Typography.Text
                            className="mb-0"
                            style={{
                              color: "#003087",
                              paddingLeft: 20,
                              fontSize: 14,
                            }}
                          >
                            {item.sNo}
                          </Typography.Text>
                        </Col>
                        <Col span={20}>
                          <Typography.Text
                            className="mb-0"
                            style={{ color: "#003087", fontSize: 14 }}
                          >
                            {item.question}
                          </Typography.Text>
                        </Col>
                        <Col
                          span={2}
                          style={{
                            paddingRight: 20,
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Icon
                            icon={"uis:angle-right"}
                            style={{
                              fontSize: 24,
                              color: "#003087",
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </Col>
            </Row>
          </Col>
          <Col span={4}></Col>
        </Row>
      </WrapperLayout>
    </>
  );
};
